export interface PixleeWidgetInitializerOptions {
  widgetId: number;
  containerId: string;
  skuId?: number;
  categoryName?: string;
  categoryId?: number;
  accountId: number;
  subscribedEvents: string[];
}

class PixleeWidgetInitializer {
  private widgetId: number;

  private type: string;

  private skuId?: number;

  private categoryId?: number;

  private categoryName?: string;

  private containerId: string;

  private accountId: number;

  private fallbackWidget?: PixleeWidgetInitializer;

  constructor(widgetId: number, containerId: string, type: string, accountId: number) {
    this.widgetId = widgetId;
    this.containerId = containerId;
    this.type = type;
    this.accountId = accountId;
  }

  setSkuId(skuId: number) {
    this.skuId = skuId;
    this.categoryId = undefined;
    this.type = 'product';
  }

  setCategoryId(categoryId: number) {
    this.categoryId = categoryId;
    this.skuId = undefined;
    this.categoryName = undefined;
    this.type = 'category';
  }

  setCategoryName(categoryName: string) {
    this.categoryName = categoryName;
    this.skuId = undefined;
    this.categoryId = undefined;
    this.type = 'category';
  }

  simpleWidget() {
    this.categoryId = undefined;
    this.skuId = undefined;
    this.type = 'simple';
  }

  setFallbackWidget(pixleeWidget: PixleeWidgetInitializer) {
    this.fallbackWidget = pixleeWidget;
  }

  getFallbackWidget() {
    return this.fallbackWidget;
  }

  getType() {
    return this.type;
  }

  toOptions() {
    const options = {} as PixleeWidgetInitializerOptions;
    options.widgetId = this.widgetId;
    options.containerId = this.containerId;

    if (this.skuId) {
      options.skuId = this.skuId;
    }

    if (this.categoryName) {
      options.categoryName = this.categoryName;
    }

    if (this.categoryId) {
      options.categoryId = this.categoryId;
    }

    options.accountId = this.accountId;

    return options;
  }
}

export default PixleeWidgetInitializer;
